import { render, staticRenderFns } from "./NewVariableInput.vue?vue&type=template&id=07101c73&scoped=true&"
import script from "./NewVariableInput.vue?vue&type=script&lang=ts&"
export * from "./NewVariableInput.vue?vue&type=script&lang=ts&"
import style0 from "./NewVariableInput.vue?vue&type=style&index=0&id=07101c73&lang=scss&scoped=true&"
import style1 from "./NewVariableInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07101c73",
  null
  
)

export default component.exports